import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Button from "react-bootstrap/Button";

function UserInput(props) {
  const submitFinishLine = (e) => {
    e.preventDefault();
    props.handleGuess(e.target[0].value);
  };

  console.log(props.lineStart);
  return (
    <form onSubmit={submitFinishLine}>
      <div style={{ fontSize: "28px" }}>
        Guesses Remaining: {props.guessesCount}
      </div>
      <InputGroup className="mb-3" style={{ padding: "10px" }}>
        <InputGroup.Text><h3>Enter a guess:</h3></InputGroup.Text>
        <Form.Control placeholder={props.lineStart} disabled={props.gameOver} />
        <Button variant="primary" disabled={props.gameOver} type="submit">
          <h3>Submit Guess</h3>
        </Button>
      </InputGroup>
    </form>
  );
}

export default UserInput;
